// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.errorText_TqCUX {
  align-self: flex-start;
  height: 0;
  transition: height 0.1s linear;
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/api-ui-login/lib/views/FieldErrorsComponent.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,SAAS;EACT,8BAA8B;AAChC","sourcesContent":[".errorText {\n  align-self: flex-start;\n  height: 0;\n  transition: height 0.1s linear;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"errorText": `errorText_TqCUX`
};
export default ___CSS_LOADER_EXPORT___;
